export const GST_RATE = 0.18;

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

// GST is charged on top of the entered (base) amount.
// base = wallet credit, total = amount actually charged.
export const computeGst = (base) => {
  const amount = round2(base);
  if (!amount || amount <= 0) {
    return { base: 0, gstRate: GST_RATE, gstAmount: 0, total: 0 };
  }
  const gstAmount = round2(amount * GST_RATE);
  return {
    base: amount,
    gstRate: GST_RATE,
    gstAmount,
    total: round2(amount + gstAmount),
  };
};

// GST already included in `gross` (e.g. wallet-funded rental). gross stays what's paid.
export const extractInclusive = (gross) => {
  const total = round2(gross);
  if (!total || total <= 0) {
    return { taxable: 0, gstRate: GST_RATE, gstAmount: 0, total: 0 };
  }
  const taxable = round2(total / (1 + GST_RATE));
  return { taxable, gstRate: GST_RATE, gstAmount: round2(total - taxable), total };
};

export const formatMoney = (amount) =>
  Number(amount || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
